// extracted by mini-css-extract-plugin
export default {"productGrid":"d1-z","centerLink":"e1-z","productSection":"f1-z","item":"g1-z","ctaButton":"h1-z"};